<template>
  <AppSelect
    :items="buildIncrementalArray(MAX_QUANTITY, 1)"
    :label="$tt('quantity_select.label')"
    :hint="getHint()"
    persistent-hint
  />
</template>

<script setup lang="ts">
import { MAX_QUANTITY } from '~/assets/constants';
import { buildIncrementalArray } from '~/helpers/general';
import type { Product } from '~/types';

const props = defineProps<{
  product?: Product;
}>();

const { tt } = useLocalization();

function getHint() {
  const ages = props.product?.ages;
  if (ages) {
    const { min, max } = ages;
    return tt('quantity_select.hint_range', { min, max });
  }
  return tt('quantity_select.hint_all');
}
</script>